"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOneByNameAndAppRoute = void 0;
exports.getOneByNameAndAppRoute = '/admin/';
//# sourceMappingURL=getOneByNameAndApp.route.js.map